<template>
  <div class="ndvi">
    <div class="top_img">
      <img :src="imgUrl" alt="" />
    </div>
    <div class="wrap">
      <img v-if="imgRouteUrl" :src="imgRouteUrl" alt="" />
    </div>
    <div class="color-line">
      <div class="line"></div>
      <div class="nums">
        <div class="item" v-for="item in nums" :key="item">{{ item }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgRouteUrl: '',
      imgUrl: '',
      nums: [-1, -0.8, -0.6, -0.4, -0.2, 0, 0.2, 0.4, 0.6, 0.8, 1],
    }
  },

  mounted() {
    const { fileId, imgUrl } = this.$route.query

    console.log('imgurl:', imgUrl)
    this.imgUrl = imgUrl
    this.getData(fileId)
  },

  methods: {
    async getData(fileId) {
      await this.$toast.loading({
        message: this.$t('common.loading'),
        forbidClick: true,
        duration: 0,
      })

      await this.$api.generateNDVI({ fileId }).then((res) => {
        if (res.ndviHotMapBase64) {
          this.imgRouteUrl = 'data:image/jpg;base64,' + res.ndviHotMapBase64
        } else {
          this.$toast.fail({
            message: res.errmsg,
          })
        }
      })

      setTimeout(() => {
        this.$toast.clear()
      }, 1500)
    },
  },
}
</script>

<style lang="scss" scoped>
.ndvi {
  padding-top: 20px;
}

.wrap {
  min-height: 211px;
  margin: 0 15px 0;

  background: grey;

  img {
    width: 100%;
  }
}

.color-line {
  .line {
    height: 14px;
    margin: 15px;
    box-sizing: border-box;
    background-image: linear-gradient(
      to right,
      blue,
      green,
      yellow,
      orange,
      red
    );
  }
}

.nums {
  display: flex;
  font-size: 14px;
  margin: 0 15px;

  .item {
    flex: 1;
    text-align: center;

    &:first-child {
      text-align: left;
    }
    &:last-child {
      text-align: right;
    }
  }
}

.top_img {
  // width: auto;
  padding: 15px;
  box-sizing: border-box;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
